import React, { useState } from "react";

import ArrowUp from "../assets/img/icon/arrow-up.png";
import ScrollDown from "../assets/img/icon/scroll-down.png";
import ScrollDownHover from "../assets/img/icon/scroll-down-hover.png";
import FooterScrollBtn from "./FooterScrollBtn";
import ScrollFront from "../assets/img/icon/scroll-front.png";
import ScrollFrontHover from "../assets/img/icon/scroll-front-hover.png";

function Footer(props) {
  const [hover, setHover] = useState(false);

  return (
    <footer className="absolute px-16 w-screen bottom-16 text-white flex flex-row justify-between z-50">
      {/* footer for 1st slide */}
      {props.slide === 0 && (
        <div className="w-full flex flex-row justify-center items-center gap-10 absolute -bottom-10 left-0">
          <hr className="w-[40%]" />
          <FooterScrollBtn
            slide={props.slide}
            slideTo={props.slideTo}
            isEnd={props.isEnd}
            setHover={setHover}
            className=""
            src={hover ? ScrollDownHover : ScrollDown}
            onClick={() => {
              props.slideTo(props.slide + 1);
              setHover(false);
            }}
          />
          <hr className="w-[40%]" />
        </div>
      )}

      {/* left scroll up arrow */}
      {props.slide !== 0 && (
        <button
          type="button"
          className="flex flex-row justify-start items-baseline absolute bottom-0 left-14"
          onClick={() => props.slideTo(props.slide - 1)}
        >
          <img src={ArrowUp} alt="arrow up" className="" />
          <hr className="w-[50px]" />
        </button>
      )}

      {/* right scroll down arrow */}
      {props.slide !== 0 && !props.isEnd && (
        <div className="flex flex-row justify-end items-center gap-3 absolute -bottom-10 right-14">
          <hr className="w-[50px]" />
          <FooterScrollBtn
            slide={props.slide}
            slideTo={props.slideTo}
            isEnd={props.isEnd}
            setHover={setHover}
            onClick={() => {
              props.slideTo(props.isEnd ? props.slide : props.slide + 1);
              setHover(false);
            }}
            src={hover ? ScrollDownHover : ScrollDown}
          />
        </div>
      )}

      {/* right scroll front arrow */}
      {props.slide !== 0 && props.isEnd && (
        <div className="flex flex-row justify-end items-center gap-3 absolute -bottom-10 right-14">
          <hr className="w-[50px]" />
          <FooterScrollBtn
            slide={props.slide}
            slideTo={props.slideTo}
            isEnd={props.isEnd}
            setHover={setHover}
            className="relative bottom-5"
            onClick={() => {
              props.slideTo(0);
              setHover(false);
            }}
            src={hover ? ScrollFrontHover : ScrollFront}
          />
        </div>
      )}
    </footer>
  );
}

export default Footer;
